import React from 'react';
import Card from 'components/card/Card';
import { ClusterCardItem } from 'types/Cluster';

const ClusterCard = ({
    label,
    description,
    created,
    updated,
    clusterUri,
}: ClusterCardItem) => {
    return (
        <Card
            label={label}
            uri={`/warehouse/${clusterUri}/`}
            type="cluster"
            description={description}
            updated={updated || created}
        />
    );
};

export default ClusterCard;
